import classNames from 'classnames';
import * as React from 'react';
import { createGlobalStyle, ThemeProvider } from 'styled-components';
import { gridCss } from '../../styles/themes/seismic/grid.js';
import { AriaLiveRegionProvider } from './AriaLiveRegions.js';
import { jsx, jsxs } from 'react/jsx-runtime';

var GRID_CSS_ID = "mntl-grid-css";
var GlobalStyles = createGlobalStyle(["", ";"], function (props) {
  return props.theme.global;
});
var Theme = function Theme(_ref) {
  var children = _ref.children,
    className = _ref.className,
    style = _ref.style,
    theme = _ref.theme;
  React.useEffect(function () {
    if (theme.global) {
      loadGridStyle();
    }
  }, [theme]);
  return /*#__PURE__*/jsx("div", {
    style: style,
    className: classNames(theme.global && "ui-theme-root", className),
    dir: theme.isRTL ? "rtl" : "ltr",
    children: /*#__PURE__*/jsx(ThemeProvider, {
      theme: theme,
      children: /*#__PURE__*/jsxs(AriaLiveRegionProvider, {
        children: [/*#__PURE__*/jsx(GlobalStyles, {}), children]
      })
    })
  });
};
Theme.displayName = "Theme";
function loadGridStyle() {
  if (process.env.NODE_ENV === "test" || document.getElementById(GRID_CSS_ID)) {
    return;
  }
  var headElement = document.getElementsByTagName("head")[0];
  var styleElement = document.createElement("style");
  styleElement.id = GRID_CSS_ID;
  styleElement.textContent = typeof gridCss.toString === "function" ? gridCss.toString() : "";
  headElement.appendChild(styleElement);
}

export { Theme };
